// let CDN_BASE_IMG = "http://cdn.rimpac-shanghai.cn/pc";
// let CDN_BASE_IMG = "/static";

// import Vue from 'vue'
// var gImg = require("./common/img.js")
import {
  CDN_BASE_IMG
} from '../../common/config.js'
let gImg = {
  index: {
    logoEN: CDN_BASE_IMG + "/image/index/logoEN.png",
    logo: CDN_BASE_IMG + "/image/index/logo.png",
    spacing: CDN_BASE_IMG + "/image/index/spacing.png",
    searchBox: CDN_BASE_IMG + "/image/index/searchBox.png",
    texture: CDN_BASE_IMG + "/image/index/texture.jpg",
    bg:CDN_BASE_IMG+'/image/footer/20220311.png'
  },
  ResearchDirection: {
    one: CDN_BASE_IMG + "/image/ResearchDirection/one.jpg",
    two: CDN_BASE_IMG + "/image/ResearchDirection/two.jpg",
    three: CDN_BASE_IMG + "/image/ResearchDirection/three.jpg",
    four: CDN_BASE_IMG + "/image/ResearchDirection/four.jpg",
    five: CDN_BASE_IMG + "/image/ResearchDirection/five.jpg",
    six: CDN_BASE_IMG + "/image/ResearchDirection/six.jpg",
    seven: CDN_BASE_IMG + "/image/ResearchDirection/seven.jpg",
    eight: CDN_BASE_IMG + "/image/ResearchDirection/eight.jpg",
  },
  CherishTalentsAndAcceptTalents: {
    one: CDN_BASE_IMG + "/image/CherishTalentsAndAcceptTalents/one.jpg",
    two: CDN_BASE_IMG + "/image/CherishTalentsAndAcceptTalents/two.jpg",
    three: CDN_BASE_IMG + "/image/CherishTalentsAndAcceptTalents/three.jpg",
    four: CDN_BASE_IMG + "/image/CherishTalentsAndAcceptTalents/four.jpg",
    five: CDN_BASE_IMG + "/image/CherishTalentsAndAcceptTalents/five.jpg"
  },
  journal: {
    one: CDN_BASE_IMG + "/image/journal/RimPac-1.jpg",
    two: CDN_BASE_IMG + "/image/journal/RimPac-2.jpg",
    three: CDN_BASE_IMG + "/image/journal/RimPac-3.jpg",
    four: CDN_BASE_IMG + "/image/journal/RimPac-4.jpg",
    five: CDN_BASE_IMG + "/image/journal/RimPac-5.jpg",
    six: CDN_BASE_IMG + "/image/journal/RimPac-6.jpg",
    seven: CDN_BASE_IMG + "/image/journal/RimPac-7.jpg",
    eight: CDN_BASE_IMG + "/image/journal/icon.jpg",
  },
  footer: {
    one: CDN_BASE_IMG + "/image/footer/one.jpg",
  },
  affairs: {
    affairs: CDN_BASE_IMG + "/image/affairs/affairs.jpg",
  },
  arrow: {
    arrow: CDN_BASE_IMG + "/image/arrow/arrow.png",
    Loading: CDN_BASE_IMG + "/image/arrow/Loading.jpg",
  }
}
export default gImg





// WEBPACK FOOTER //
// ./src/common/img.js